import type { SanityPageBuilderMediaCardsCard, SanityPageBuilderMediaCardsCardLink, SanityPageBuilderMediaCardsSection, SanityPageBuilderSection } from "@ouster/shared";
import { MediaCardsBlockView } from "~/features/blocks/inventory/media-cards";
import { MediaCardsCardView, type MediaCardsCardViewProps } from "~/features/blocks/inventory/media-cards/media-cards-card";
import { MediaCardsCardLinkView } from "~/features/blocks/inventory/media-cards/media-cards-card-link";
import { toCraftLinkArray } from "~/features/sanity/link";
import { SanityMediaFigure, hasRenderableSanityMedia } from "~/features/sanity/page-builder/sections/media-figure";
import { SanityRichText } from "~/features/sanity/rich-text";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderMediaCardsSection;
  };
};
type MediaCardsViewLink = {
  _key?: SanityPageBuilderMediaCardsCardLink["_key"];
  link?: ReturnType<typeof toCraftLinkArray>;
};
type MediaCardsViewCard = Omit<MediaCardsCardViewProps<MediaCardsViewLink>, "renderLink"> & Pick<SanityPageBuilderMediaCardsCard, "_key">;
export function SanityMediaCardsSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const cards = sectionContent.cards?.map<MediaCardsViewCard>(card => ({
    _key: card._key,
    headline: card.headline,
    links: card.links?.map<MediaCardsViewLink>(link => ({
      _key: link._key,
      link: toCraftLinkArray(link.link)
    })) ?? [],
    media: hasRenderableSanityMedia(card.media) ? <SanityMediaFigure media={card.media} ratio={sectionContent.cards?.length === 3 ? "3/2" : "16/9"} /> : undefined,
    text: card.text?.length ? <SanityRichText value={card.text} /> : undefined
  })) ?? [];
  return <MediaCardsBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} cards={cards} getCardKey={(card, index) => card._key || index} hasTopDivider={sectionSettings?.hasTopDivider ?? true} mode={sectionSettings?.mode || "light"} renderCard={card => <MediaCardsCardView headline={card.headline} links={card.links} media={card.media} renderLink={(link, index) => <MediaCardsCardLinkView key={link._key || index} link={link.link} />} text={card.text} />} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={sectionSettings?.theme || "white"} />;
}